import { DateTime } from 'luxon';
import { CallablePageRef } from 'providers/page-ref';
import { TaskStatus } from 'components/cs-task-calendar-day/cs-task-calendar-day';

export type TaskStatusLoaderResult = Map<string, TaskStatus>;

export type TaskCalendarPageParams = {
  selectedDateISO: string; // Pass dates as ISO strings for URL serialization
  title?: string;
  description?: string;
  local?: {
    taskStatusLoader?: (startDate: DateTime, endDate: DateTime) => Promise<Map<string, TaskStatus>>;
  };
};

export type TaskCalendarPageResult = {
  selectedDate: DateTime | null;
};

export const ITaskCalendarPage: CallablePageRef<TaskCalendarPageParams, TaskCalendarPageResult> = {
  pageName: 'TaskCalendarPage',
} as CallablePageRef<TaskCalendarPageParams, TaskCalendarPageResult>;
